import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { createColorEvent, editColorEvent } from '../../../_events/color/create_color.event';
import { findAllColors } from '../../../_events/color/find_colors.event';
import { message } from "antd";
import { ROLES } from "../../../_config/roles";
import RolWrapper from "../../hoc/roles_wrapper";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin,  ROLES.color]);

const Colors = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'cod', headerName: 'Referencia', width: 300 },
        { field: 'description', headerName: 'descripción', width: 400 },
        { field: '', headerName: 'Acciones', width: 100, sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem(params.row); setRender('form');
                };    
                return <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>;
            }
        },
    ];

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Colores
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'100%'}}>
                        {
                            render === 'info' ? 
                            <ButtonRolAuthComponent onClick={() => {setItem(null);setRender('form');}} variant="contained">Crear nuevo</ButtonRolAuthComponent>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                {
                    render === 'info' ? <ColorInfo columns={columns} /> : <ColorForm item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const ColorInfo = (props) => {

    const [colors, setColors] = useState([]);

    const findColors = () => {
        findAllColors()
        .then(data => {
            setColors(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findColors();
    }, []);   

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={colors}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.cod}
            />
        </div>
    );
}

const ColorForm = (props) => {
    let { item } = props; 

    const createColor = () => {
        createColorEvent()
        .then(data => {
            message.success('Creado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const editColor = (id) => {
        editColorEvent(id)
        .then(data => {
            message.success('Actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="color_cod" 
                        label="Referencia" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.cod : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="color_description" 
                        label="Descripción" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.description : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editColor(item.uuid)} variant="contained">Editar</Button>
                        : <Button style={{width: '100%'}} onClick={() => createColor()} variant="contained">Guardar</Button>
                    }      
                </Grid>                
            </Grid>
        </div>
    );
}

export default Colors;